import { useEffect, useState } from "react";

const RETRY_MS = 1500;
const FALLBACK_AFTER_MS = 6000;

const initForm = (formId, containerEl) => {
  if (window.fd) window.fd("form", { formId, containerEl });
};

export const useFlodeskForm = (formId) => {
  const [fallback, setFallback] = useState(false);
  const containerId = `fd-form-${formId}`;

  useEffect(() => {
    const containerEl = `#${containerId}`;
    initForm(formId, containerEl);
    const retry = setInterval(() => initForm(formId, containerEl), RETRY_MS);
    const check = setTimeout(() => {
      if (!document.querySelector(`${containerEl} input`)) setFallback(true);
    }, FALLBACK_AFTER_MS);
    return () => {
      clearInterval(retry);
      clearTimeout(check);
    };
  }, [formId, containerId]);

  return { containerId, fallback };
};
